<template>
  <div class="wrapper">
    <ErrorSvg class="error-svg" />

    <h3>
      {{$t('email-verification.invalid-link')}}
    </h3>

    {{$t('email-verification.invalid')}}
  </div>
</template>

<script>
import ErrorSvg from '@/components/svg/error.svg';

export default {
  name: 'EmailVerificationInvalid',
  components: {
    ErrorSvg
  }
};
</script>

<style scoped>
.error-svg {
  max-width: 168px;
  margin: 32px 0;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 32px;
}
</style>
